import { render } from "./NavCart.vue?vue&type=template&id=48c6f7e1&scoped=true"
import script from "./NavCart.vue?vue&type=script&lang=js"
export * from "./NavCart.vue?vue&type=script&lang=js"

import "./NavCart.vue?vue&type=style&index=0&id=48c6f7e1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c6f7e1"]])

export default __exports__